module.exports = __webpack_public_path__ + "img/tsvetkov.7f9b5470.png";